module.exports = __webpack_public_path__ + "224b126cfd53d82199717cc3dc163c65.svg";